module.exports = __webpack_public_path__ + "img/art-school-icon9.a64877db.png";